module.exports = __webpack_public_path__ + "img/resource-tech-image-65.e70b5ba3.jpg";